import RecentNews from "./RecentNews";

export default RecentNews;